import { getPartnerGuid } from '../../../lib/access.es6'
import { todayIso } from '../../../lib/claimEventDate.es6'

// OMK finalises documentation as of the day the assessor takes the action, so
// the date is stamped rather than asked for.
export function asksForDocsFinalisationDate() {
  return getPartnerGuid() !== 'omk'
}

export function docsFinalisationDate(typed, now) {
  return asksForDocsFinalisationDate() ? typed : todayIso(now)
}
